import React, { useEffect, useCallback, useState, useRef } from 'react';
// REACT ROUTER IMPORTS
import { useNavigate, useSearchParams } from "react-router-dom";
// MATERIAL UI IMPORT
import {
    Table, TableHead, TableContainer, TableRow, TableCell, TableBody, TablePagination,
    Box, Stack, Button, Typography, OutlinedInput, Divider, InputAdornment, IconButton, CircularProgress,
    Link
} from "@material-ui/core";
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';
import { debounce } from "lodash";
// MATERIAL STYLED
import { styled } from '@material-ui/core/styles';
// NPM IMPORTS
import moment from "moment";
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useSnackbar } from 'notistack5';
import searchFill from '@iconify/icons-eva/search-fill';
import { useSelector } from 'react-redux';
// COMPONENT IMPORTS
import { MIconButton } from '../../../../../components/@material-extend';
import Scrollbar from '../../../../../components/Scrollbar';
import AnalyticsWrapper from "../../../analyticswrapper";
import { PATH_DASHBOARD } from "../../../../../routes/paths";
// Context IMPORTS
import { AnalyticContext } from "../../../../../contexts/AnalyticContext";
// UTILS IMPORTS
import { setFilterByHeader } from "../../../../../utils/filterUtilities";
// API IMPORTS
import { getAcceptanceByResultApi, getAcceptanceByTeamResultApi, getAcceptanceByResultDownloadXLS, downloadResultAcceptanceList, downloadAcceptanceByResult } from "../../../../../_apis_/authApi.js/analytic_api";

// Import Style CSS
import "../../../../../assets/styles.css";
import GlobalChip from '../../../../Common Component/globalChip';

// Import Progress Loader
import LinearProgressWithLabel from '../../../../Common Component/LinearProgressWithLabel';
import TimedLinearProgressWithLabel from '../../../../../components/TimedLinearProgressWithLabel';
import { useFileDownload } from '../../../../../hooks/useFileDownload';

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
    width: 240,
    height: 40,
    margin: "12px 0",
    transition: theme.transitions.create(['box-shadow', 'width'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter
    }),
    '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
    '& fieldset': {
        borderWidth: `1px !important`,
        borderColor: `${theme.palette.grey[500_32]} !important`
    }
}));



export default function AcceptanceResultTable() {
    const { downloadFile, isDownloading } = useFileDownload();

    // LOCAL STORAGE
    const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));
    // SNACKBAR STATES
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    // CONTEXT STATES
    const { acceptanceByResultApiRes, getAcceptanceByResult, loadingMap, setModuleLoading } = React.useContext(AnalyticContext);
    // REACT ROUTER STATES
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    // STATES
    const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const [page, setPage] = React.useState(0);
    const [cPage, setCPage] = useState(0);
    const [showPage, setShowPage] = useState(false)
    // const [searchData, setSearchData] = useState('')

    const [data, setData] = React.useState([]);
    // const [isLoading, setModuleLoading['AccceptByRes1.11', true] = React.useState(false);
    const [filterName, setFilterName] = React.useState("");
    const [count, setCount] = React.useState(0);
    const [supGrp, setSupGrp] = React.useState(loggedUserData?.groups?.map(obj => obj.id));
    const [filterObj, setFilterObj] = useState('')
    const [tableOrder, setTableOrder] = useState(false);
    const [showIcon, setShowIcon] = useState(false);

    const filterFieldsData = useSelector(state => state?.filterFields?.filterFieldsData)

    // USE-EFFECT METHODS
    useEffect(() => {

        if (searchParams.get("link") !== "Supervisor") {
            setModuleLoading('AccceptByRes1.11', true);
            setData([]);
            fetchAcceptanceByResultData(1);
        }
    }, [searchParams]);

    const searchPage = Number(localStorage.getItem('newPage_2.4'))

    const buildFilterObj = useCallback(() => ({
        'fromDate': searchParams.get("date1") || '',
        'toDate': searchParams.get("date2") || '',
        'filterBy': searchParams.get("filter") || 'created_at',
        'teams': searchParams.get('teams') || filterFieldsData?.teams || '',
        'scoreCard': searchParams.get("scorcard") || '',
        "scoreCardGroups": searchParams.get("group") || filterFieldsData?.group || '',
        'eventType': filterFieldsData?.eventType || '',
        "eventTypeEventSubType": filterFieldsData?.eventTypeEventSubType || '',
        'supervisor': searchParams.get("supervisor") || '',
        "staff": filterFieldsData?.staff || '',
        "scoreCardCategory": filterFieldsData?.scoreCardCategory || '',
        'evaluator': filterFieldsData?.evaluator || '',
        "highlightValue": filterFieldsData?.highlightValue || '',
        'page': showPage ? cPage + 1 : page + 1,
        'filterName': '',
        'flag': '',
        'section': filterFieldsData?.section || '',
        "numericValues": filterFieldsData?.numericValues || undefined,
        'formula': filterFieldsData?.formula || '',
        'isScoreViewed': searchParams.get("viewed") || '',
        'isScoreReviewed': searchParams.get("reviewed") || '',
        'noAction': searchParams.get("noaction") || '',
        'isScoreAccepted': searchParams.get("accepted") || '',
        'isOneToOneReq': searchParams.get("one2one") || '',
        'dataTag': searchParams?.get('dataTag') || filterFieldsData?.dataTag || '',
        'dataTagsOperator': searchParams?.get('dataTagsOperator') || filterFieldsData?.anyOfTag || filterFieldsData?.allOfTag || filterFieldsData?.dataTagsOperator || '10',
        'search': filterName || ''
    }), [searchParams, filterFieldsData, showPage, cPage, page, filterName])

    // 2.4
    useEffect(() => {
        if (searchParams.get("link") === 'Supervisor') {
            setFilterObj(buildFilterObj())
            getAcceptanceByResult(buildFilterObj());
        }

    }, [page, cPage]);

    useEffect(() => {
        if (searchParams.get("link") === 'Supervisor') {
            setData(acceptanceByResultApiRes?.results ?? []);
            setCount(acceptanceByResultApiRes?.count ?? 0);
        }

    }, [acceptanceByResultApiRes])

    const fetchAcceptanceByResultData = async (pgNo, query) => {

        setModuleLoading('AccceptByRes1.11', true);
        setData([]);
        try {
            if (searchParams.get("isTeamResult") === "False") {
                const { data } = await getAcceptanceByResultApi(searchParams.get("date1"), searchParams.get("date2"), searchParams.get("filter"), searchParams.get("agent") || "", searchParams.get("scorcard") === 'all' ? '' : searchParams.get("scorcard"), searchParams.get("envnt") === 'all' ? '' : searchParams.get("envnt"), searchParams.get("subEvnt") === 'all' ? '' : searchParams.get("subEvnt"), searchParams.get("eval") === 'all' ? '' : searchParams.get("eval"), searchParams.get("scorecard_group") || "", (loggedUserData?.staff && loggedUserData?.staff?.staffType !== 10 ? supGrp.join(',') : ""), searchParams.get("viewed") || "", searchParams.get("accepted") || "", searchParams.get("one2one") || "", searchParams.get("reviewed") || "", searchParams.get("noaction") || "", pgNo, query || "", searchParams.get('dataTag'), searchParams.get('dataTagsOperator'));
                setData(data?.results);
                setCount(data?.count);
            } else {
                const { data } = await getAcceptanceByTeamResultApi(searchParams.get("date1"), searchParams.get("date2"), searchParams.get("filter"), searchParams.get("agent") || "", searchParams.get("scorcard") === 'all' ? '' : searchParams.get("scorcard"), searchParams.get("envnt") === 'all' ? '' : searchParams.get("envnt"), searchParams.get("subEvnt") === 'all' ? '' : searchParams.get("subEvnt"), searchParams.get("eval") === 'all' ? '' : searchParams.get("eval"), searchParams.get("scorecard_group") || "", (loggedUserData?.staff && loggedUserData?.staff?.staffType !== 10 ? supGrp.join(',') : ""), searchParams.get("team") || "", searchParams.get("viewed") || "", searchParams.get("accepted") || "", searchParams.get("one2one") || "", searchParams.get("reviewed") || "", searchParams.get("noaction") || "", pgNo, query || "", searchParams.get('dataTag') || '', searchParams.get('dataTagsOperator') || '');
                setData(data?.results);
                setCount(data?.count);
            }
            setModuleLoading('AccceptByRes1.11', false);
        } catch (err) {
            setData([]);
            setCount([]);
            setModuleLoading('AccceptByRes1.11', false);
        }
    }

    const handleTableOrder = () => {
        setData(data.reverse());
        setTableOrder(!tableOrder)
    }

    // METHODS
    const handleChangePage = (event, newPage) => {
        if (searchParams.get("link") !== 'Supervisor') {
            fetchAcceptanceByResultData(newPage + 1, filterName);
            setPage(newPage);
        } else if (showPage && count > 100) {
            localStorage.setItem('newPage_2.4', newPage)
            setCPage(newPage)
            setShowPage(true)
            setData([]);
            setModuleLoading('AccceptByRes1.11', true);


        } else {
            localStorage.setItem('newPage_2.4', 0)
            localStorage.setItem('pageNo_2.4', newPage)

            setPage(newPage);
            setShowPage(false)
            setData([]);
            setModuleLoading('AccceptByRes1.11', true);


        }
    }

    const handleSearchFun = (filterObject, searchVal) => {
        setFilterName(searchVal);
        if (searchParams.get("link") !== 'Supervisor') {
            setPage(0);
            setModuleLoading('AccceptByRes1.11', true);
            setData([]);
            fetchAcceptanceByResultData(1, searchVal?.trim());
        } else if ((searchVal || filterName) === '') {
            const pageNo = Number(localStorage?.getItem('pageNo_2.4'))
            setData([]);
            localStorage.setItem('newPage_2.4', 0)
            setCPage(0)
            setModuleLoading('AccceptByRes1.11', true);
            setShowPage(false)
            getAcceptanceByResult({
                ...buildFilterObj(),
                search: searchVal ? searchVal?.trim() : filterName || '',
                page: pageNo + 1
            });

        } else {
            setCPage(0)

            setShowPage(true)
            getAcceptanceByResult({
                ...buildFilterObj(),
                search: searchVal ? searchVal?.trim() : filterName || '',
                page: cPage + 1 // fix nested pagination for nested child page
                // page: searchPage + 1
            });

        }

    }
    // Delay search by 600ms
    const delayedSearch = useCallback(
        debounce((filterObj, val) => handleSearchFun(filterObj, val), 600), []);

    const handleFilterByName = (e) => {
        delayedSearch(filterObj, e.target.value);
    }

    const handleDownloadAcceptanceByResult = async () => {
        if (searchParams.get("link") !== 'Supervisor') {
            const filterObj = {
                date1: searchParams.get("date1"),
                date2: searchParams.get("date2"),
                filter: searchParams.get("filter"),
                staff: searchParams.get("agent") || "",
                scorecard: searchParams.get("scorcard") === 'all' ? '' : searchParams.get("scorcard"),
                evntType: searchParams.get("envnt") === 'all' ? '' : searchParams.get("envnt"),
                evntSubtype: searchParams.get("subEvnt") === 'all' ? '' : searchParams.get("subEvnt"),
                evaluator: searchParams.get("eval") === 'all' ? '' : searchParams.get("eval"),
                scorecardGroup: searchParams.get("scorecard_group") || "",
                supGrp: loggedUserData?.staff && loggedUserData?.staff?.staffType !== 10 ? supGrp : "",
                team: searchParams.get("team") || "",
                isViewed: searchParams.get("viewed") || "",
                isAccepted: searchParams.get("accepted") || "",
                isOnetoOne: searchParams.get("one2one") || "",
                isReviewed: searchParams.get("reviewed") || "",
                noAction: searchParams.get("noaction") || "",
                dataTag: searchParams.get('dataTag') || '',
                dataTagsOperator: searchParams.get('dataTagsOperator') || '10'
            }
            downloadFile({
                apiFunction: getAcceptanceByResultDownloadXLS,
                apiParams: filterObj,
                baseFileName: '1.11_Acceptance_by_result_',
                extension: 'xlsx'
            });
        }

        // 2.4
        if (searchParams.get("link") === 'Supervisor') {

            // downloadAcceptanceByResult(filterObj);
            downloadFile({
                apiFunction: downloadAcceptanceByResult,
                apiParams: buildFilterObj(),
                baseFileName: '2.4 Result Acceptance By Supervisor Xls',
                extension: 'xlsx'
            });
        }
    }


    const mbLink = [{ name: 'Home', href: PATH_DASHBOARD.general.dashboard }]

    switch (searchParams.get("link")) {

        case 'Teams':
            mbLink.push({ name: 'Analytics', href: "/analytics" },
                { name: "Result Acceptance By Team", href: `/analytics/acceptance_by_team?date1=${searchParams.get("date1")}&date2=${searchParams.get("date2")}&filter=${searchParams.get("filter")}&scorcard=${searchParams.get("scorcard")}&envnt=${searchParams.get("envnt")}&subEvnt=${searchParams.get("subEvnt")}&eval=${searchParams.get("eval")}&scorecard_group=${searchParams.get("scorecard_group")}&link=Groups` },
                { name: "Acceptance By Result" });
            break;

        case 'Agents':
            mbLink.push({ name: 'Analytics', href: "/analytics" },
                { name: "Staff", href: "" },
                // { name: "1.11 Result Acceptance By Staff", href: `/analytics/staff/acceptance_by_agent?fromDate=${searchParams.get("date1")}&toDate=${searchParams.get("date2")}&filterBy=${searchParams.get("filter")}&scoreCard=${searchParams.get("scorcard")}&eventType=${searchParams.get("envnt")}&eventTypeEventSubType=${searchParams.get("subEvnt")}&teams=${searchParams.get("teams") || ''}&group=${searchParams.get("scorecard_group")}&scoreCardGroups=${searchParams.get("scorecard_group")}&staff=${searchParams.get('staff') || ''}&evaluator=${searchParams.get('eval') || ''}&section=${searchParams.get('section') || ''}&scoreCardSingle=${searchParams.get('scoreCardSingle') || ''}&dataTag=${searchParams.get('dataTag')}&dataTagsOperator=${searchParams.get('dataTagsOperator')}&search=${searchParams.get('search')}` },
                { name: "1.11 Result Acceptance By Staff", href: `/analytics/staff/acceptance_by_agent` },
                { name: "Acceptance By Result" });
            break;
        case 'Supervisor':
            mbLink.push({ name: 'Analytics', href: "/analytics" },
                { name: "Supervisors", href: `/analytics/supervisor/result_acceptence_by_supervisor?fromDate=${searchParams.get('date1')}&toDate=${searchParams.get('date2')}&dateRange=${searchParams.get('dateRange') || ''}&filterBy=${searchParams.get('filter')}&group=${searchParams.get("group")}&scoreCard=${searchParams.get('scorcard')}&eventType=${searchParams.get("envnt") || ""}&eventTypeEventSubType=${searchParams.get('subEvnt') || ""}&evaluator=${searchParams.get('eval')}&supervisor=${searchParams.get("supervisor")}` },
                { name: "2.4 Result Acceptance By Superviosr", href: `/analytics/supervisor/result_acceptence_by_supervisor` },
                // { name: "2.4 Result Acceptance By Superviosr", href: `/analytics/supervisor/result_acceptence_by_supervisor?fromDate=${searchParams.get('date1')}&toDate=${searchParams.get('date2')}&filterBy=${searchParams.get('filter')}&group=${searchParams.get("group")}&scoreCard=${searchParams.get('scorcard')}&eventType=${searchParams.get("envnt") || ""}&eventTypeEventSubType=${searchParams.get('subEvnt') || ""}&evaluator=${searchParams.get('eval')}&supervisor=${searchParams.get("supervisor")}&teams=${searchParams.get('teams')}&dateRange=${searchParams.get('dateRange') || ''}&dataTag=${filterFieldsData?.dataTags || searchParams.get('dataTag') || ''}&dataTagsOperator=${searchParams.get('dataTagsOperator') || '10'}` },
                { name: "Acceptance By Result" });
            break;
        default:
            mbLink.push({ name: 'Analytics', href: "/analytics" }, { name: "Acceptance By Result" });
            break;
    }

    const handleReviewPerformancePage = (row) => {
        navigate(`/reports/reviewPerformance?score_card_Id=${row?.scoreCardId}&score_Id=${row?.id}&review=True&stff_sup_id=${row?.staff_id}&sup_view=True&from_result_details=True`)
        localStorage.setItem("tabLabel", JSON.stringify("Staff Review"))
        localStorage.setItem("tabState", JSON.stringify('6'))

        // sessionStorage.setItem('fromDate', searchParams.get("date1") || '',);
        // sessionStorage.setItem('toDate', searchParams.get("date2") || '');
        // sessionStorage.setItem('filterBy', searchParams.get("filter") || 'created_at');
        // sessionStorage.setItem('teams', searchParams.get('teams') || filterFieldsData?.teams || '');
        // sessionStorage.setItem('scoreCard', searchParams.get("scorcard") || '');
        // sessionStorage.setItem("scoreCardGroups", filterFieldsData?.group || '');
        // sessionStorage.setItem('eventType', filterFieldsData?.eventType || '');
        // sessionStorage.setItem("eventTypeEventSubType", filterFieldsData?.eventTypeEventSubType || '');
        // sessionStorage.setItem('supervisor', searchParams.get('supervisor') === 'null' ? '' : searchParams.get('supervisor'));
        // sessionStorage.setItem("staff", filterFieldsData?.staff || '');
        // sessionStorage.setItem("scoreCardCategory", filterFieldsData?.scoreCardCategory || '');
        // sessionStorage.setItem('evaluator', filterFieldsData?.evaluator || '');
        // sessionStorage.setItem('section', filterFieldsData?.section || '');
        // sessionStorage.setItem("numericValues", filterFieldsData?.numericValues || undefined);
        // sessionStorage.setItem('formula', filterFieldsData?.formula || '');
        // sessionStorage.setItem('supervisor', (searchParams.get('supervisor') === 'null' ? '' : searchParams.get('supervisor')))
    }

    const handleDate = (row) => {
        let date = '';
        if (searchParams.get('filter') === 'created_at') {
            date = row?.createdAtDate
        }
        if (searchParams.get('filter') === 'event_date') {
            date = row?.eventDateAt
        }
        if (searchParams.get('filter') === 'updated_at') {
            date = row?.updatedAtDate
        }
        return date;

    }
    return (
        <>
            <AnalyticsWrapper val="6" sbVal="6.12" subModule="Acceptance By Result" LabelName="" brdCrmbLink={mbLink} dwnldFn={handleDownloadAcceptanceByResult}>
                <Box >
                    <Stack sx={{ width: "100%", px: 2 }} direction="row" alignItems="center" alignContent="center" justifyContent="space-between">
                        {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} placeholderName="Search Group..." /> */}
                        <SearchStyle
                            // value={filterName}
                            onChange={handleFilterByName}
                            placeholder="Search..."
                            startAdornment={
                                <>
                                    <InputAdornment position="start">
                                        <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                                    </InputAdornment>
                                </>
                            }
                        />

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography variant="body2" >Row PerPage:&nbsp;100</Typography>
                            <TablePagination
                                sx={{ border: "1px solid transparent" }}
                                rowsPerPageOptions={[100]}
                                component="div"
                                count={count || 0}
                                rowsPerPage={rowsPerPage}
                                page={showPage ? cPage : page}
                                onPageChange={handleChangePage}
                            />
                        </Box>


                    </Stack>
                    <Divider />
                    <Box>
                        <Scrollbar>
                            <TableContainer id="beyondAnalyticsTable" sx={{
                                minWidth: "400px",
                                maxHeight: '500px',
                                mb: 1,
                                height: { xs: data?.length > 0, sm: data?.length > 0, md: data?.length > 0, lg: data?.length > 0, xl: data?.length > 0 }
                            }}>
                                <Table size='medium' sx={{

                                    "& .MuiTableCell-root": {
                                        border: (theme) => `1px solid ${theme.palette.text.primaryBorder}`,

                                    },

                                    "& .MuiTableCell-root:first-of-type": {
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                        boxShadow: 'none',
                                    },
                                    "& .MuiTableCell-root:last-of-type": {
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                        boxShadow: 'none',
                                    },
                                }} >

                                    <TableHead >
                                        <TableRow >
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                <Stack sx={{ width: '100%' }} onMouseEnter={() => setShowIcon(true)} onMouseLeave={() => setShowIcon(false)} flexDirection='row' justifyContent='center' alignItems='center'>
                                                    <>Id</>
                                                    {showIcon && <IconButton onClick={handleTableOrder}>
                                                        {!tableOrder ? <ArrowUpward fontSize='small' /> : <ArrowDownward fontSize='small' />}
                                                    </IconButton>}
                                                </Stack>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                {setFilterByHeader(searchParams.get('filter'))}
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Status Date
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Staff Name
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Supervisor
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Team
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Group
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Evaluator
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "90px" }} align="center">
                                                Score
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                Scorecard Name
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                <Typography noWrap sx={{ fontWeight: 'inherit', fontSize: 'inherit' }}>Last Edit Date</Typography>
                                            </TableCell>
                                        </TableRow>


                                    </TableHead>
                                    <TableBody>
                                        {/* 1.11 module */}
                                        {data?.length > 0 && searchParams.get("link") !== "Supervisor" && data?.map((row, index) => (<TableRow key={index} >
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                <Button onClick={() => {
                                                    navigate(`/reports/reviewPerformance?score_card_Id=${row?.score_card?.id}&score_Id=${row?.id}&review=True&stff_sup_id=${row?.staff_id}&sup_view=True&from_result_details=True`)
                                                }}>
                                                    {row?.id}
                                                </Button>
                                            </TableCell>
                                            {searchParams.get('filter') === 'event_date' &&
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                    <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                        {row?.event_date !== null ? moment(row?.event_date).format('YYYY-MM-DD') : null}
                                                    </Typography>
                                                </TableCell>}
                                            {searchParams.get('filter') === 'created_at' &&
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                    <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                        {row?.created_at !== null ? moment(row?.created_at).format('YYYY-MM-DD') : null}
                                                    </Typography>
                                                </TableCell>}
                                            {searchParams.get('filter') === 'updated_at' &&
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                    <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                        {row?.updated_at !== null ? moment(row?.updated_at).format('YYYY-MM-DD') : null}
                                                    </Typography>
                                                </TableCell>}
                                            <TableCell sx={{ px: 1, margin: "0 auto" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {!row?.score_reviewed_on ? "" : moment(row?.score_reviewed_on).format('YYYY-MM-DD')}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.staff}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.supervisor}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.teams?.name}

                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.teams?.groups?.name}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.evaluator}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "90px" }} align="center">
                                                <GlobalChip
                                                    label={`${row?.percentage} %`}
                                                    type={row?.score_result}
                                                    sx={{
                                                        minHeight: { lg: '25px', xl: '30px' },
                                                        maxHeight: { lg: '25px', xl: '30px' },
                                                        minWidth: '80px', maxWidth: '80px',
                                                        mr: 2,
                                                    }}
                                                    fn={() => {
                                                        navigate(`/reports/reviewPerformance?score_card_Id=${row?.score_card?.id}&score_Id=${row?.id}&review=True&stff_sup_id=${row?.staff_id}&sup_view=True&from_result_details=True`)
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.score_card?.name}
                                                </Typography>
                                            </TableCell>

                                            <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                <Typography noWrap sx={{ fontSize: { xs: '14px', xl: '15px' } }}>
                                                    {row?.updated_at !== null ? moment(row?.updated_at).format('YYYY-MM-DD') : null}
                                                </Typography>
                                            </TableCell>

                                        </TableRow>))}

                                        {/* 2.4 section table result--- */}

                                        {(data?.length > 0 && searchParams.get("link") === "Supervisor") &&
                                            (data?.map((row, index) => (<TableRow key={index} >
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                    <Link
                                                        onClick={() => handleReviewPerformancePage(row)}
                                                        style={{ color: '#0045FF', cursor: 'pointer' }}
                                                    >
                                                        <Typography noWrap sx={{ fontSize: "14px" }}>{`${row?.id}`}</Typography>
                                                    </Link>
                                                    {/* <Button sx={{ color: "#005fe3" }} onClick={() => handleReviewPerformancePage(row)}>{row?.id}</Button> */}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center" padding='normal'>
                                                    {handleDate(row)}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.statusDate}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.staffName}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.supervisorName}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.teamsName}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.groupName}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.evaluatorName}
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "90px" }} align="center">

                                                    <GlobalChip
                                                        label={`${row?.score} %`}
                                                        type={row?.scoreResult}
                                                        sx={{
                                                            minHeight: { lg: '25px', xl: '30px' },
                                                            maxHeight: { lg: '25px', xl: '30px' },
                                                            minWidth: '80px', maxWidth: '80px',
                                                            mr: 2,
                                                        }}
                                                        fn={() => {
                                                            handleReviewPerformancePage(row)
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.scorecardName}
                                                </TableCell>

                                                <TableCell sx={{ px: 1, margin: "0 auto", minWidth: "100px" }} align="center">
                                                    {row?.lastEditDate}
                                                </TableCell>

                                            </TableRow>)))

                                        }
                                        {
                                            data?.length === 0 && searchParams.get("link") === "Supervisor" && (<TableRow>

                                                {loadingMap['AcceptanceByResult2.4'] ? <TableCell colSpan={12}>
                                                    <TimedLinearProgressWithLabel active={loadingMap['AcceptanceByResult2.4']} /> :

                                                </TableCell> : <TableCell colSpan={12}>
                                                    <Typography gutterBottom align="center" variant="subtitle1" sx={{ py: 2 }}>

                                                        No Data Found
                                                    </Typography>
                                                </TableCell>}

                                            </TableRow>)
                                        }
                                        {data?.length === 0 && searchParams.get("link") !== "Supervisor" && (
                                            <TableRow>

                                                {loadingMap['AccceptByRes1.11'] ?
                                                    <TableCell colSpan={12}>
                                                        <TimedLinearProgressWithLabel active={loadingMap['AccceptByRes1.11']} />
                                                    </TableCell> : <TableCell colSpan={12}>
                                                        <Typography gutterBottom align="center" variant="subtitle1" sx={{ py: 2 }}>

                                                            No Data Found
                                                        </Typography>
                                                    </TableCell>}

                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Scrollbar>
                    </Box>
                </Box>
            </AnalyticsWrapper>

        </>
    )
}